<ng-container *ngIf="action === 'status'">
    <ion-button expand="block" [disabled]="disabled" (click)="getDeviceStatus()">Gerätestatus abfragen</ion-button>
    <ng2-smart-table *ngIf="isCore && settings" (userRowSelect)="rowSelect($event.data)" [settings]="settings"
                                 [source]="tableData"></ng2-smart-table>
</ng-container>

<ion-button *ngIf="action==='device-config'" expand="block" [disabled]="disabled" (click)="setDeviceConfig()">Gerätekonfiguration übertragen</ion-button>

<ion-button *ngIf="action==='device-reset'" expand="block" [disabled]="disabled" (click)="resetDeviceConfig()">Gerätekonfiguration zurücksetzen</ion-button>